import React from "react"
import LightGallery from "lightgallery/react"

import "./Gallery.scss"

// import css
import "lightgallery/css/lightgallery.css"
import "lightgallery/css/lg-zoom.css"
import "lightgallery/css/lg-thumbnail.css"

// import plugins if you need
import lgThumbnail from "lightgallery/plugins/thumbnail"
import lgZoom from "lightgallery/plugins/zoom"

function Gallery({galleryImages = [{ url: "", alt: ""}]}) {
  const IMGLoop = () => {
    
    return galleryImages.map((image, index) => (
      <a
        data-lg-size="1200-1200"
        className="gallery__imagelink"
        key={index}
        href={image.url}
      >
        <img
          src={image.url}
        />
      </a>
    ))
  }

  const onInit = () => {
    console.log("lightGallery has been initialized")
  }

  return (
    <div className="gallery">
      <LightGallery
        onInit={onInit}
        speed={500}
        plugins={[lgThumbnail, lgZoom]}
        elementClassNames="gallery-wrapper"
      >
        <IMGLoop />
      </LightGallery>
    </div>
  )
}

export default Gallery
